// export default LazyImageComponent;
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css'; // Optional: For a blur effect

const LazyImageComponent = ({ imageUrl, alt, onClick }) => {
  return (
    <div onClick={onClick}>
      <LazyLoadImage
        alt={alt}
        effect="blur" // You can also use 'opacity' or other effects
        src={imageUrl}
        style={{
          transition: 'opacity 0.3s ease, transform 0.2s ease',
        }}
      />
    </div>
  );
};

export default LazyImageComponent;
